import { useDispatch, useSelector } from 'react-redux'
import { tryChangePageSettings } from '../../../../redux/slices/dynamicUiSlice'
import CustomCheckBox from '../../../../components/form/CustomCheckBox'


//supports pinning and setting vertical tabs type
const PageTabMenu = ({isPinType= true}={}) => {

  const dispatch = useDispatch()

  const isLoading = useSelector((state) => state.dynamicElements.editing.loading)
  const selectedGroup = useSelector((state) => (state.dynamicUi.pages.selectedGroup));
  const pageData = useSelector((state) => (state.dynamicUi.pages[selectedGroup].data));
  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage));

  const isActive = isPinType ? pageData[selectedPage]?.is_sticky_header: pageData[selectedPage]?.is_vertical


  const handleChange = (e) => {
    dispatch(tryChangePageSettings({active: e.target.checked, isPinType: isPinType}));
  }

  return (
    <CustomCheckBox disabled={isLoading} checked={isActive}
                      onChange={handleChange} className="mb-4" label={isPinType ? "Pin Tabs (Recommended)":"Vertical Tab Orientation"}/>

  )
}

export default PageTabMenu
